module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"removeConfirm":"Are you sure you want to delete this note?","addResult":"Add result","assignToMe":"Assign to me"},"et":{"removeConfirm":"Are you sure you want to delete this note?","addResult":"Add result","assignToMe":"Assign to me"},"ru":{"removeConfirm":"Are you sure you want to delete this note?","addResult":"Add result","assignToMe":"Assign to me"}}')
  delete Component.options._Ctor
}
